import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Alert/sgds-alert-link";
import { register } from "../../utils/ce-registry";

register("sgds-alert-link", Component);

export default createComponent({
  react: React,
  tagName: "sgds-alert-link",
  elementClass: Component,
  events: {}
});
